var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.012,
    height: 12.012,
    viewBox: "0 0 12.012 12.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M11.906.492a.241.241,0,0,1,0,.4l-.516.516a.241.241,0,0,1-.4,0L8.156-1.43a.27.27,0,0,1-.094-.187v-.328A4.731,4.731,0,0,1,4.875-.75,4.7,4.7,0,0,1,1.43-2.18,4.7,4.7,0,0,1,0-5.625,4.7,4.7,0,0,1,1.43-9.07,4.7,4.7,0,0,1,4.875-10.5,4.7,4.7,0,0,1,8.32-9.07,4.7,4.7,0,0,1,9.75-5.625a4.731,4.731,0,0,1-1.2,3.188h.328a.223.223,0,0,1,.188.094ZM2.227-2.977a3.611,3.611,0,0,0,2.648,1.1,3.611,3.611,0,0,0,2.648-1.1,3.611,3.611,0,0,0,1.1-2.648,3.611,3.611,0,0,0-1.1-2.648,3.611,3.611,0,0,0-2.648-1.1,3.611,3.611,0,0,0-2.648,1.1,3.611,3.611,0,0,0-1.1,2.648A3.611,3.611,0,0,0,2.227-2.977Z",
    transform: "translate(0 10.5)",
    fill: "#8c8b97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f0a8e13e59c3dca45b0a997ab868ef38.svg";
export { ForwardRef as ReactComponent };